export const organizationTypes = ["PERSONAL", "AGENCY"] as const;

export type OrganizationType = (typeof organizationTypes)[number];

export type OrganizationUserRole = "OWNER" | "MANAGER" | "STANDARD";

export type Organization = {
   id: string;
   type: OrganizationType;
   userRole: OrganizationUserRole;
   name: string;
   imageUrl?: string;
   description: string;
   phone: string;
   email: string;
   website: string;
   createdBy: string;
   archivedAt?: string;
   createdAt: string;
   updatedAt: string;
};
